import { SystemIcon } from "@justworkshr/milo-components";
import styles from "./HealthAppUpsellStepper.module.css";

const HealthAppUpsellStepper = (): JSX.Element => {
  const upsellSteps = [
    {
      title: "Submit application",
      content: [
        "Our underwriting team will review the information you submitted and see what plans are available.",
      ],
    },
    {
      title: "Compile plans and pricing",
      content: [
        "In around 3-5 business days, we’ll email some options that make the most sense for your team. If you have any questions about the plans we selected, feel free to drop us a line at",
        "One thing to keep in mind–we’ll do our best to help your team get health insurance coverage, but it's not guaranteed. We have lots of other ways to help your company grow and succeed, even if you don’t end up getting health insurance with us.",
      ],
    },
    {
      title: "Review your plans and get started",
      content: [
        "After you select your plans, we’ll email the documents that need to be signed and then kick off plan selection for your team!",
      ],
    },
  ];
  const [step1, step2, step3] = upsellSteps;

  return (
    <div className={styles.stepsContainer}>
      <div data-testid="health-ins-status-step" className={styles.step}>
        <div className={styles.successIcon}>
          <SystemIcon
            iconName="check"
            color="inverse"
            title="person"
            size="extra-small"
          />
        </div>

        <div className={styles.stepMessage}>
          <span className={`${styles.stepTitle} ${styles.successTitle}`}>
            {step1.title}
          </span>
          <div className={styles.description}>
            <div>{step1.content}</div>
          </div>
        </div>
      </div>

      <div data-testid="health-ins-status-step" className={styles.step}>
        <div className={styles.successIcon}>
          <div className={styles.stepNumber}>2</div>
        </div>

        <div className={styles.stepMessage}>
          <span className={styles.stepTitle}>{step2.title}</span>
          <div className={styles.description}>
            <div>
              {step2.content[0]}{" "}
              <a
                className="milo--link"
                href="mailto:support@justworks.com."
                target="_blank"
                rel="noreferrer"
              >
                support@justworks.com.
              </a>
            </div>
            <div>{step2.content[1]}</div>
          </div>
        </div>
      </div>

      <div data-testid="health-ins-status-step" className={styles.step}>
        <div className={styles.successIcon}>
          <div className={styles.stepNumber}>3</div>
        </div>

        <div className={styles.stepMessage}>
          <span className={styles.stepTitle}>{step3.title}</span>
          <div className={styles.description}>
            <div>
              {step3.content}{" "}
              <a
                className="milo--link"
                href="mailto:enrollment@justworks.com"
                target="_blank"
                rel="noreferrer"
              >
                enrollment@justworks.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthAppUpsellStepper;
